"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    { label: 'Crimson Core', value: 'Crimson Core' },
    { label: 'Medview', value: 'Medview' },
    { label: 'Crimson Athletics', value: 'Crimson Athletics' },
    { label: 'Tours', value: 'Tours' },
    { label: 'Crimson Rise', value: 'Crimson Rise' },
    { label: 'Partnership', value: 'Partnership' },
    { label: 'CGA', value: 'CGA' },
    { label: 'Tutoring Ecommerce', value: 'Tutoring Ecommerce' },
    { label: 'Medview Ecommerce', value: 'Medview Ecommerce' },
    { label: 'Postgraduate', value: 'Postgraduate' },
    { label: 'Transfer', value: 'Transfer' },
    { label: 'Tutoring', value: 'Tutoring' },
    { label: 'Boarding/Day School', value: 'Boarding/Day School' },
    { label: 'Crimson Careers', value: 'Crimson Careers' },
    { label: 'Dux College', value: 'Dux College' },
    { label: 'CRI', value: 'CRI' },
    { label: 'Off Menu', value: 'Off Menu' },
];
//# sourceMappingURL=serviceCategories.js.map